import { render } from "./BannerCardSimulator.vue?vue&type=template&id=37d7eab8&scoped=true"
import script from "./BannerCardSimulator.vue?vue&type=script&lang=js"
export * from "./BannerCardSimulator.vue?vue&type=script&lang=js"

import "./BannerCardSimulator.vue?vue&type=style&index=0&id=37d7eab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d7eab8"]])

export default __exports__